/* axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import { MDAConstant } from '../../../MDA/Designer/Base/MDAConstant';
import { StorageLib, EnumStorageType } from './StorageLib';
import router from '@/router/index';

// 环境的切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'https://gateway.yuanxingcloud.com/';
  // axios.defaults.baseURL = 'http://localhost:7000/';
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = 'http://localhost:7000/';
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://gateway.yuanxingcloud.com/';
}

// 请求超时时间
axios.defaults.timeout = 1000000;

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';

// // 请求拦截器
// axios.interceptors.request.use(
//     config => {
//         // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//         // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
//         const token = store.state.token;
//         token && (config.headers.Authorization = token);
//         return config;
//     },
//     error => {
//         return Promise.error(error);
//     })

axios.interceptors.request.use(config => {
  let token = StorageLib.instance.getItem<string>(EnumStorageType.Expiration, MDAConstant.Account.SATOKEN);
  if (token === null) {
    token = '';
  }
  let tenancyId = StorageLib.instance.getItem<string>(EnumStorageType.Expiration, MDAConstant.Account.TENANCY_ID);
  if (tenancyId === null) {
    tenancyId = '';
  }
  let userid = StorageLib.instance.getItem<string>(EnumStorageType.Expiration, MDAConstant.Account.USER_ID);
  if (userid === null) {
    userid = '';
  }
  const now = new Date();
  config.headers.satoken = token;
  config.headers.tenancyid = tenancyId;
  config.headers.userid = userid;
  config.headers['x-ca-reqid'] = now.getTime().toString();
  config.headers['x-ca-reqtime'] = now.getTime().toString();
  return config;
});

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200 && response.data.Success === true) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // 清除记录信息
          StorageLib.instance.clearAll();
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          // Toast({
          //     message: '登录过期，请重新登录',
          //     duration: 1000,
          //     forbidClick: true
          // });
          // 清除token
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //     router.replace({
          //         path: '/login',
          //         query: {
          //             redirect: router.currentRoute.fullPath
          //         }
          //     });
          // }, 1000);
          break;
        // 404请求不存在
        case 404:
          // Toast({
          //     message: '网络请求不存在',
          //     duration: 1500,
          //     forbidClick: true
          // });
          console.log('return 404');
          break;
        // 其他错误，直接抛出错误提示
        default:
          // Toast({
          //   message: error.response.data.message,
          //   duration: 1500,
          //   forbidClick: true
          // });
          break;
      }
      return Promise.reject(error.response);
    }
  }
);

/*
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

class QueryHelper {
  static ToUrlQuery(data: any, name: string, params: Array<string> = []): string {
    if (typeof data === 'undefined' || data == null) {
      return '';
    }
    let json = '';
    if (Array.isArray(data)) {
      data.forEach((item, index) => {
        this.ToUrlQuery(item, `${name}[${index}]`, params);
      });
    } else if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean' || typeof data === 'symbol' || typeof data === 'bigint') {
      params.push(this.ToUrlItem(String(data), name));
    } else if (data instanceof Date) {
      params.push(this.ToUrlItem(data.toISOString(), name));
    } else {
      const keys = Object.keys(data);
      for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];

        if (data[key] === null) {
          continue;
        }

        this.ToUrlQuery(data[key], `${name === '' ? '' : name + '.'}${key}`, params);
      }
    }
    json = params.join('&');
    return json;
  }

  static ToUrlItem(data: string, name: string) {
    return `${name}=${data}`;
  }
}

export function get(url: string, params: any = '', name = '') {
  // console.log('get ' + url);
  return new Promise((resolve, reject) => {
    axios
      .get(url + '?' + QueryHelper.ToUrlQuery(params, name))
      .then((res) => {
        // console.log('get back :');
        // console.log(res);
        resolve(res.data.Data);
      })
      .catch((err) => {
        // console.log('error : ');
        // console.log(err);
        reject(err.Message);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url: string, params: any) {
  // console.log(url);
  return new Promise((resolve, reject) => {
    axios
      .post(url, JSON.stringify(params))
      .then((res) => {
        // console.log('get back :');
        // console.log(res);
        resolve(res.data.Data);
      })
      .catch((err) => {
        // console.log('error : ');
        // console.log(err);
        reject(err.data.Message);
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url: string, params: any) {
  // console.log(url);
  return new Promise((resolve, reject) => {
    axios
      .put(url, JSON.stringify(params))
      .then((res) => {
        // console.log('get back :');
        // console.log(res);
        resolve(res.data.Data);
      })
      .catch((err) => {
        // console.log('error : ');
        // console.log(err);
        reject(err.data.Message);
      });
  });
}

/**
 * del方法，对应del请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url: string, params: any = '', name = '') {
  return new Promise((resolve, reject) => {
    axios
      .delete(url + '?' + QueryHelper.ToUrlQuery(params, name))
      .then((res) => {
        // console.log('get back :');
        // console.log(res);
        resolve(res.data.Data);
      })
      .catch((err) => {
        // console.log('error : ');
        // console.log(err);
        reject(err.data.Message);
      });
  });
}
